/* Delegated so quick-buy and variant refreshes use the current photograph. */
(() => {
  const triggers = new WeakMap();
  document.addEventListener('click', event => {
    const trigger = event.target.closest?.('.ps-gallery-zoom');
    if (trigger) {
      const gallery = trigger.closest('.ps-photo-gallery');
      const dialog = gallery?.querySelector('.ps-photo-lightbox');
      if (!dialog) return;
      const image = dialog.querySelector('img');
      image.src = gallery.classList.contains('ps-notes-active') ? trigger.dataset.photoNotes : trigger.dataset.photoClean;
      const preview = trigger.querySelector('img');
      image.alt = trigger.dataset.photoAlt || preview?.alt || image.alt;
      for (const dimension of ['width', 'height']) {
        const value = trigger.dataset[dimension === 'width' ? 'photoWidth' : 'photoHeight'] || preview?.getAttribute(dimension);
        if (value) image.setAttribute(dimension, value);
      }
      dialog.setAttribute('aria-label', image.alt);
      image.loading = 'eager';
      triggers.set(dialog, trigger);
      if (!dialog.open) dialog.showModal();
      return;
    }
    const close = event.target.closest?.('.ps-photo-lightbox__close');
    const dialog = close?.closest('.ps-photo-lightbox');
    if (dialog) dialog.close();
    else if (event.target.matches?.('dialog.ps-photo-lightbox')) {
      const bounds = event.target.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) event.target.close();
    }
  });
  // Keep a nested quick-buy drawer open when Escape dismisses the photograph.
  document.addEventListener('keydown', event => {
    const dialog = event.target.closest?.('.ps-photo-lightbox[open]');
    if (event.key !== 'Escape' || !dialog) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    dialog.close();
  }, true);
  document.addEventListener('close', event => {
    if (!event.target.matches?.('.ps-photo-lightbox')) return;
    const trigger = triggers.get(event.target);
    if (trigger?.isConnected) trigger.focus({ preventScroll: true });
  }, true);
})();
